class SavedAddressesController {
    constructor(moveFocus, addressService) {
        this.moveFocus = moveFocus;
        this.addressService = addressService;
    }

    $onInit() {
        this.addressService.getSavedAddresses().then(() => {
            this.savedAddresses = this.addressService.savedAddresses;
            if (this.savedAddresses && this.savedAddresses.length > 0) {
                this.moveFocus('#savedAddresses-results');
            }
        });
    }

    setEntryMode(mode) {
        if (this.isNewFulfilmentMethodSelector) {
            this.heading = mode === 'MANUAL' ? 'Enter a new delivery address' : 'Choose a location';
        }
    }
}

const savedAddressesComponentDefinition = {
    bindings: {
        heading: '@',
        isGuest: '<',
        onSavedAddressSelected: '&?',
        onSaveNewManualAddress: '&',
        onSaveNewAutoAddress: '&',
        saveAddressError: '<?',
        saveAddressErrorTitle: '@?',
        isNewFulfilmentMethodSelector: '<?',
        selectedAddress: '=?',
    },
    controller: ['MoveFocus', 'AddressService', SavedAddressesController],
    template: require('./saved-addresses.component.html').trim(),
};

module.exports = {
    SavedAddressesController,
    savedAddressesComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/address/saved-addresses.component.js